import { Reducer } from 'redux';

import { loadApp } from '../services/app';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = loadApp(), action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.UI_INTEGRATE_UPDATED:
      return {
        ...state,
        configuredExpanded: action.configuredExpanded,
      };
    case ActionTypes.UI_BYOD_UPDATED:
      return {
        ...state,
        byodExpanded: action.byodExpanded,
      };
    case ActionTypes.UI_TEMPLATES_UPDATED:
      return {
        ...state,
        templatesExpanded: action.templatesExpanded,
      };
    case ActionTypes.UI_WEBHOOK_UPDATED:
      return {
        ...state,
        webhookExpanded: action.webhookExpanded,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/reducers/app.ts